import useHeaderSelectedAIModel from "../store/useHeaderSelectedAIModel";
import logger from "../services/Logger";
import { runMessageStream, updateRegenerateMessage, updateAnswerUsage, addGenerateErrorMessage } from "../utils/streamingUtils";
import { generateMessageApi } from "./generate/messageOperations";
import { createMessageLoadingHandlers } from "./generate/useMessageLoading";
import PromptStore from "../store/promptStore";

export const handleEditSend = async ({
  id,
  prompt_id,
  turn_id,
  source_prompt_id,
  source_answer_id,
  chat_id,
  messages,
  setRegenerateIndex,
  setIsLatestMessageLoading,
  user,
  orgId,
  assetIds = [],
  modeRef,
  apiUrl,
  index,
  newPrompt,
  prevPrompt,
  setGenerateStatus,
  space,
  answer_id,
  chat,
  agent,
  onApprovalCard, // Callback for approval card events
  queryClient, // React Query client for cache updates
  deviceId = null,
  styleSelection = null,
  styleVersionId = null,
  modelId = null,
  modelOverride = false,
  webSearchEnabled = null,
}) => {
  // Initialize loading state handlers
  const loadingHandlers = createMessageLoadingHandlers({
    setIsLatestMessageLoading,
    setGenerateStatus,
    setRegenerateIndex,
    chat_id,
  });

  // Snapshot activeSkills synchronously before any awaits
  const activeSkills = PromptStore.getState().activeSkills || [];

  try {
    // Start loading state
    loadingHandlers.startLoading(id, index, answer_id);
    // Use unified API
    const reader = await generateMessageApi({
      operation: 'edit',
      prompt: prevPrompt,
      newPrompt,
      chatId: chat_id,
      promptId: prompt_id,
      answerId: answer_id,
      turnId: turn_id,
      sourcePromptId: source_prompt_id,
      sourceAnswerId: source_answer_id,
      apiUrl,
      space,
      chat,
      user,
      orgId,
      modeRef,
      modelId: modelId || useHeaderSelectedAIModel.getState()?.selectedModel?.id,
      modelOverride,
      assetIds: Array.isArray(assetIds) ? assetIds : [],
      messages,
      activeSkills,
      webSearchEnabled,
      deviceId,
      styleSelection,
      styleVersionId,
    });

    // Use shared message-stream wiring. Edit path writes directly to cache
    // (no chunk buffering) and uses stopLoading() instead of cleanup().
    await runMessageStream({
      reader,
      messageId: id,
      loadingHandlers,
      cleanupMethod: 'stopLoading',
      buffered: false,
      checkStillPending: false,
      writeChunk: (content) => {
        if (queryClient && chat_id) {
          updateRegenerateMessage(
            queryClient,
            chat_id,
            space?.space_id,
            id,
            answer_id,
            content,
          );
        }
      },
      onApprovalCard,
      onUsage: (data) =>
        updateAnswerUsage(queryClient, chat_id, space?.space_id, id, data.answer_id, data),
    });
  } catch (error) {
    const handled = loadingHandlers.handleError(error);
    if (!handled) {
      logger.error('EditedPrompt', 'Error fetching messages', { error: error.message, chat_id, messageId: id });
      // Mirrors generate.js/regenerate.js's catch — without this the user got
      // zero feedback on an edit failure: the spinner just disappeared with no
      // inline error and no toast (handleError only toasts generation_limit_reached).
      addGenerateErrorMessage(
        queryClient,
        chat_id,
        space?.space_id,
        id,
        "\n" + (error.message || "Something went wrong while generating the response. Please try again.")
      );
    }
  }
};
